// extracted by mini-css-extract-plugin
export var faqContent = "actionfaq-module--faq-content--bAz0r";
export var title = "actionfaq-module--title--+x0gp";
export var header = "actionfaq-module--header--fd-YT";
export var desc = "actionfaq-module--desc--5IBSp";
export var catList = "actionfaq-module--cat-list--I5k+v";